import React, { useEffect, useState } from 'react'
import EditorUC from '../../../components/editorUC'
import { FaRegFilePdf } from 'react-icons/fa'
import { BsFiletypePng } from 'react-icons/bs'
import { AiOutlineFileJpg } from 'react-icons/ai'
import { urlAttachFileRc } from '../../../config/axios-rc'
import ButtonUC from '../../../components/buttonUC';
import { ShareAltOutlined } from '@ant-design/icons';
import SharedModal from '../../../components/sharedModal'

const ContentRight = (props) => {
    const { job, handleClickApply } = props
    const urlAttachFile = urlAttachFileRc()
    const [openModal, setOpenModal] = useState(false)
    const getIcon = (fileType) => {
        if (fileType.toLowerCase().includes('pdf')) {
            return <FaRegFilePdf className='icon-pdf icon' />
        } else if (fileType.toLowerCase().includes('png')) {
            return <BsFiletypePng className='icon-png icon' />
        } else if (fileType.toLowerCase().includes('jpeg')) {
            return <AiOutlineFileJpg className='icon-jpg icon' />
        }
    }

    const [attData, setAttData] = useState(null)

    useEffect(() => {
        if (job?.attachFile) {
            const _attachFile = job.attachFile.map(e => {
                return setDataAttachFile(e)
            })
            setAttData(_attachFile)
        }
    }, [job.attachFile])

    const handleShare = (job) => {
        console.log('handleShare', job)
        setOpenModal(true)
    }

    const handleCancelModal = () => {
        setOpenModal(false)
    }

    const setDataAttachFile = (data) => {
        //------ ไฟล์แนบจะบันทึกในรูปแบบ string คั่นด้วย ',' ----------//
        const fileNameArr = data.fileName.substring(0, 1) === ',' ? data.fileName.substring(1, data.fileName.length).split(',') : data.fileName.split(',')
        const fileTypeArr = data.fileType.substring(0, 1) === ',' ? data.fileType.substring(1, data.fileType.length).split(',') : data.fileType.split(',')
        const filePathArr = data.filePath.substring(0, 1) === ',' ? data.filePath.substring(1, data.filePath.length).split(',') : data.filePath.split(',')
        const _attachFiles = []
        let _data = []
        for (let i = 0; i < fileNameArr.length; i++) {
            const extension = filePathArr[i]?.split('.').length > 1 ? filePathArr[i].split('.')[1] : ''
            _attachFiles.push({
                sort: i + 1,
                fileNameOriginal: fileNameArr[i] === 'commanderApprove' ? `แบบฟอร์มหนังสือรับรองให้มาสมัครงาน${'.' + extension}` : fileNameArr[i],
                filePath: filePathArr[i],
                fileBase64: "",
                fileType: fileTypeArr[i],
            })
        }
        _data = { ...data, attachFiles: _attachFiles, isDisabled: false }
        return _data
    }

    const convertToDate = (val) => {
        let _date = val ? new Date(val) : new Date();
        _date.setHours(0, 0, 0, 0);
        return _date;
    };

    const _stratDate = convertToDate(job?.startDate)
    const _endDate = convertToDate(job?.endDate)
    const _currentDate = convertToDate()

    return (
        <div className='content-right flex flex-col'>
            <div className="title text-center">รายละเอียดงาน</div>
            <div className="detail h-full w-full">
                {job.responsibility &&
                    <div className="job-detail mb-6">
                        <div className="job-detail-title pb-2 mb-2">
                            หน้าที่รับผิดชอบ
                        </div>
                        <div className="job-detail-data">
                            <EditorUC value={job.responsibility} />
                        </div>
                    </div>
                }
                {job.qualification &&
                    <div className="job-detail mb-6">
                        <div className="job-detail-title pb-2 mb-2">
                            คุณสมบัติ
                        </div>
                        <div className="job-detail-data">
                            <EditorUC value={job.qualification} />
                        </div>
                    </div>
                }
                {job.employmentTypeName &&
                    <div className="job-detail mb-6">
                        <div className="job-detail-title pb-2 mb-2">
                            ประเภทการว่าจ้าง
                        </div>
                        <div className="job-detail-data">
                            {job.employmentTypeName}
                        </div>
                    </div>
                }
                {job.benefit && job.benefit.length > 0 &&
                    <div className="job-detail mb-6">
                        <div className="job-detail-title pb-2 mb-2">
                            สวัสดิการ
                        </div>
                        <div className="job-detail-data pl-6">
                            <ul>
                                {job.benefit.map((item, index) => {
                                    return (
                                        <li className='benefit-list' key={index}>{item} </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                }
                {job.address &&
                    <div className="job-detail mb-6">
                        <div className="job-detail-title pb-2 mb-2">
                            สถานที่ทำงาน
                        </div>
                        <div className="job-detail-data workPlace">
                            {job.address === 'ไม่ระบุ' && job.province === 'ไม่ระบุ' ? 'ไม่ระบุ' : `${job.address} ${job.province}`}
                        </div>
                        {job.latitude && job.longitude &&
                            <div className="work-place-url pt-2">
                                <a href={`https://www.google.co.th/maps/@${job.latitude},${job.longitude},18z?hl=th&entry=ttu`} target='_blank' rel="noreferrer">คลิกเพื่อดูแผนที่</a>
                            </div>
                        }
                    </div>
                }
                {job.document && job.document.length > 0 &&
                    <div className="job-detail mb-6">
                        <div className="job-detail-title pb-2 mb-2">
                            เอกสารที่ต้องแนบ
                        </div>
                        <div className="job-detail-data pl-6">
                            <ul>
                                {job.document.map((item, index) => {
                                    return (
                                        <li className='document-list' key={index}>{item} </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                }
                {attData && attData.length > 0 &&
                    <div className="attachFile job-detail mb-6">
                        <div className="job-detail-title pb-2 mb-2">
                            เอกสารประกาศรับสมัครงาน
                        </div>
                        <div className="job-detail-data pt-2">
                            {attData.map(att => {
                                if (att.attachFiles && att?.attachFiles.length > 0) {
                                    return att.attachFiles.map((item, index) => {
                                        return (
                                            <div className='attach-file-list flex pb-2' key={index}>
                                                <a href={urlAttachFile + item.filePath} target='_blank'
                                                    download={item.fileNameOriginal}
                                                    className='file-name flex'>
                                                    <span className='attach-file-icon mr-2'>{getIcon(item.fileType)}</span> {item.fileNameOriginal}
                                                </a>
                                            </div>
                                        )
                                    })
                                }
                            })}

                        </div>
                    </div>
                }
            </div>
            {job?.status && job?.status !== 'draft' && job?.jobRequestType !== 'inside' &&
                (job?.isPublish && (_stratDate <= _currentDate && ((_endDate >= _currentDate) || !job?.endDate))) &&
                <div className="content-title-bottom  flex items-center justify-end">
                    <ButtonUC className='btn-apply btn-custom mr-4' onClick={() => handleClickApply()}>สมัครงาน</ButtonUC>
                    <div className='cursor-pointer' onClick={() => handleShare(job)}>
                        <ShareAltOutlined className='icon-footer' />
                    </div>
                </div>
            }
            {openModal &&
                <SharedModal
                    data={job}
                    open={openModal}
                    handleCancel={handleCancelModal}
                />}
        </div>
    )
}

export default ContentRight
